<template>
  <div>
    <b-container>
      <b-row align-h="center">
        <b-col cols="12">
          <h2 class="font-weight-bold mt-5 text-center">Login To Admin Panel</h2>
          <b-card title="Enter Your Email & Password">
            <b-form @submit.prevent="login">
              <b-form-group
                  :state="!validation.hasError('email')"
                  :invalid-feedback="validation.errorTitle('email')"
                  label="Email">
                <b-input type="email" v-model="form.email" placeholder="example@email.com"></b-input>
              </b-form-group>
              <b-form-group
                  :state="!validation.hasError('password')"
                  :invalid-feedback="validation.errorTitle('password')"
                  label="Password">
                <b-input type="password" v-model="form.password"></b-input>
              </b-form-group>

              <b-form-group class="text-center">
                <b-button
                    type="submit"
                    class="btn-round" variant="success">Login
                </b-button>
              </b-form-group>
            </b-form>
          </b-card>
        </b-col>

      </b-row>
    </b-container>

  </div>
</template>

<script>
import Http from '../../Services/HttpService/HttpService'
import Validation from '../../Services/Validation/Validation'
import Notification from '../../Services/Notification/Nottification'

export default {
  name: "Login",
  data() {
    return {
      form: {
        email: null,
        password: null
      },
      isSubmit: false,
      validation: new Validation()
    }
  },
  methods: {
    login() {
      this.$Progress.start();
      this.isSubmit = true;
      Http.post(Http.apiurl() + 'auth/login', {
        email: this.form.email,
        password: this.form.password,
        tokenValidate: this.$route.params.token
      })
          .then(response => {
            this.$Progress.finish();
            this.isSubmit = false;
            if (response.data.status_code === Http.ok()) {
              Notification.success(response.data.message);
              localStorage.setItem('tokenAdmin', response.data.data.token);
              localStorage.setItem('role', response.data.data.role);

              //redirect login
              this.redirectLogin(response.data.data.role);


            } else {
              Notification.error(response.data.message);
              this.validation.store(response.data.data);
            }
          })
          .catch(error => {
            this.$Progress.finish();
            this.isSubmit = false;
          })
    },
    checkTokenValidateAccess() {
      if (this.$route.params.token) {
        Http.post(Http.apiurl() + 'auth/check/token/access', {
          token: this.$route.params.token
        })
            .then(response => {
              if (response.data.status_code === Http.ok()) {
                localStorage.setItem('role', response.data.data.role);
                //redirect login
                // this.redirectLogin(response.data.data.role);
                Notification.success('Token Validation Success')
              } else {
                window.location.href = Http.addressImage();
              }
            })
            .catch(error => {
              window.location.href = Http.addressImage();
            })
      } else {
        window.location.href = Http.addressImage();
      }

    },
    redirectLogin(role) {
      if (role === 'order_manager') {
        window.location = Http.websiteUrl() + 'admin/orders';
      } else if (role === 'admin' || role === 'manager') {
        window.location = Http.websiteUrl() + 'admin/orders';
      } else if (role === 'seo_manager') {
        window.location = Http.websiteUrl() + 'admin/shop';
      }
    }
  },
  computed: {
    checkIsSubmitLogin() {
      return this.isSubmit === true;
    }
  },
  mounted() {
    //this.checkTokenValidateAccess();
  }
}
</script>

<style scoped>

</style>